import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import LoginView from './components/LoginView';
import HomeView from './components/HomeView/HomeView';
import WorkoutProgressionView from './components/WorkoutProgressionView/WorkoutProgressionView';
import MaxLiftsView from './components/MaxLiftsView/MaxLiftsView';
import LeaderboardsView from './components/LeaderboardsView/LeaderboardsView';
import ProfileView from './components/ProfileView/ProfileView';
import './App.css';

type AppView = 'home' | 'workout' | 'maxLifts' | 'leaderboards' | 'profile';

const App: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentView, setCurrentView] = useState<AppView>('home');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <LoginView 
        isLoggedIn={isLoggedIn} 
        setIsLoggedIn={setIsLoggedIn} 
      />
    );
  }

  const renderCurrentView = () => {
    switch (currentView) {
      case 'home':
        return <HomeView />;
      case 'workout':
        return <WorkoutProgressionView />;
      case 'maxLifts':
        return <MaxLiftsView />;
      case 'leaderboards':
        return <LeaderboardsView />;
      case 'profile':
        return <ProfileView />;
      default:
        return <HomeView />;
    }
  };

  return (
    <div className="app-container">
      <div className="app-content">
        {renderCurrentView()}
      </div>
      
      <nav className="bottom-navigation">
        <button 
          className={`nav-item ${currentView === 'home' ? 'active' : ''}`}
          onClick={() => setCurrentView('home')}
        >
          <span className="nav-icon">🏠</span>
          <span className="nav-label">Home</span>
        </button>
        
        <button 
          className={`nav-item ${currentView === 'workout' ? 'active' : ''}`}
          onClick={() => setCurrentView('workout')}
        >
          <span className="nav-icon">💪</span>
          <span className="nav-label">Workout</span>
        </button>
        
        <button 
          className={`nav-item ${currentView === 'maxLifts' ? 'active' : ''}`}
          onClick={() => setCurrentView('maxLifts')}
        >
          <span className="nav-icon">📊</span>
          <span className="nav-label">Max Lifts</span>
        </button>
        
        <button 
          className={`nav-item ${currentView === 'leaderboards' ? 'active' : ''}`}
          onClick={() => setCurrentView('leaderboards')}
        >
          <span className="nav-icon">🏆</span>
          <span className="nav-label">Rankings</span>
        </button>
        
        <button 
          className={`nav-item ${currentView === 'profile' ? 'active' : ''}`}
          onClick={() => setCurrentView('profile')}
        >
          <span className="nav-icon">👤</span>
          <span className="nav-label">Profile</span>
        </button>
      </nav>
    </div>
  );
};

export default App;
